import { Steps, Step } from 'components/Docs/Steps';
import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import InstallAngular from "../../../../contents/docs/integrate/_snippets/install-angular.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSymbolSets from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-symbol-sets.tsx";
import * as React from 'react';
export default {
  Steps,
  Step,
  InstallWebPackageManagers,
  InstallAngular,
  StepVerifyErrorTracking,
  StepUploadSymbolSets,
  React
};